import { HubConnectionState } from './hub-connection-state';
import { createAction, props } from '@ngrx/store';
import { IDomainMessage } from '../lemans-app.model';

export const updateConnectionState = createAction(
  '[SignalR] Update Connection Status',
  props<{ payload: HubConnectionState; error?: any }>(),
);

export const retrySignalRConnection = createAction('[SignalR] Retry SignalR connection');

export const disconnect = createAction('[SignalR] Stop SignalR connection');

export const setDomainMessageReceived = createAction(
  '[SignalR] Domain message received',
  props<{ payload: IDomainMessage }>(),
);
